import { render, staticRenderFns } from "./xfy.vue?vue&type=template&id=549f7996&"
import script from "./xfy.vue?vue&type=script&lang=js&"
export * from "./xfy.vue?vue&type=script&lang=js&"
import style0 from "./xfy.vue?vue&type=style&index=0&id=549f7996&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports